import React, { useEffect, useState } from 'react';
import { ReportTemplate } from '@ais-ui/websockets';
import { useDateTimeFormat } from '../conversions/useDateFormat';
import { useGetScheduleHint } from './useGetScheduleHint';
import { numberToWeekday } from './weekdays';
import { numberToMonth } from './months';

interface ScheduleDetailsProps {
  reportTemplate: ReportTemplate;
}

export const ScheduleDetails = React.memo(
  ({ reportTemplate }: ScheduleDetailsProps) => {
    const { formatDateWithTimeZone } = useDateTimeFormat();
    const getScheduleHint = useGetScheduleHint();

    const [hintSchedule, setHintSchedule] = useState<string | null>(null);
    const [hintNextJob, setHintNextJob] = useState<string | null>(null);

    useEffect(() => {
      const interval = reportTemplate.schedule?.interval as string;
      let intervalStart = '';
      if (interval === 'weekly') {
        intervalStart = numberToWeekday(
          reportTemplate.schedule?.intervalStart as number
        );
      } else if (interval === 'yearly') {
        intervalStart = numberToMonth(
          reportTemplate.schedule?.intervalStart as number
        );
      }
      const hint = getScheduleHint(
        interval,
        intervalStart,
        reportTemplate.schedule?.endTime as Date,
        '00:00'
      );
      if (!hint) {
        return;
      }
      setHintSchedule(hint.scheduleText);
      setHintNextJob(hint.nextJobText);
    }, [
      getScheduleHint,
      reportTemplate.schedule?.endTime,
      reportTemplate.schedule?.interval,
      reportTemplate.schedule?.intervalStart,
    ]);

    return (
      <div className="flex flex-col py-2 px-4 w-full space-y-4">
        <div className="flex flex-col gap-1">
          <div className="text-sm font-medium flex-none">Schedule</div>
          <div className="text-sm text-muted-foreground flex-grow text-ellipsis overflow-hidden">
            {hintSchedule}
          </div>
        </div>
        <div className="flex flex-col gap-1">
          <div className="text-sm font-medium flex-none">Next job</div>
          <div className="text-sm text-muted-foreground flex-grow text-ellipsis overflow-hidden">
            {hintNextJob}
          </div>
        </div>
      </div>
    );
  }
);

ScheduleDetails.displayName = 'ScheduleDetails';
